<template>
  <v-card flat>
    <v-toolbar flat primary-title>
      Shippings
      <v-spacer />
      <v-btn outlined @click="newItem()">Add Shipping</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :options.sync="options"
      :items="shippings"
      :server-items-length="totalCount"
    >
      <template #[`item.enabled`]="{ item }">
        {{item.enabled ? 'Yes' : 'No'}}
      </template>
      <template #[`item.tax_included`]="{ item }">
        {{item.tax_included ? 'Yes' : 'No'}}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn small outlined @click="editItem(item)" class="mr-2">
          Edit
        </v-btn>
        <v-btn small outlined :color="item.enabled ? 'warning' : 'success'" class="mr-2" @click="toggle(item)">
          {{ item.enabled ? 'Desactivate' : 'Activate' }}
        </v-btn>
        <v-btn small outlined color="error" @click="deleteItem(item)">
          Delete
        </v-btn>
      </template>
    </v-data-table>
    
    <shipping-form
        v-model="formOpen"
        :item="editedItem"
        @update="addItem"
        @add="addItem"
        :id="this.locationId"
      ></shipping-form>
  </v-card>  
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ShippingForm from "./ShippingForm.vue";
export default {
  components: {
    ShippingForm
  },
  data : () => ({
      formOpen: false,
      editedItem: null,
      headers: [
        { value: 'name', text: 'Name'},
        { value: 'price', text: 'Price'},
        { value: 'enabled', text: 'Enabled'},
        { value: 'tax_included', text: 'Tax included'},
        { value: 'actions', text: 'Actions'},
      ],
      options: {

      }
  }),
  props: ["locationId"],
  mounted: function() {
    this.load()
  },
  watch:{
    options:{
      deep: true,
      handler () {
        this.load()
      }
    },
    locationId() {
      this.load()
    }
  },
  computed: {
    ...mapGetters('shippings', ['shippings', 'loading', 'totalCount'])
  },
  methods: {
    ...mapActions('shippings', { fetchShippings: 'index', delete: 'delete'}),
    load() {
      this.fetchShippings({pagination: this.options, filters: { locationId: this.locationId, all: true }});
    },
    toggle(item) {
      this.$store
          .dispatch("shippings/toggle", {
            model: item
          })
          .catch((res) => {
            this.flashMessage.error({
              message: res.message,
            });
          })
          .then(() => {
            this.load()
            this.flashMessage.success({
              message: "Shipping updated",
            });
          });
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.load()
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    newItem() {
      this.editItem = null
      this.formOpen = true
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("shippings/delete", {
            model: item
          })
          .catch((res) => {
            this.flashMessage.error({
              message: res.message,
            });
          })
          .then(() => {
            this.load()
            this.flashMessage.success({
              message: "Shipping deleted",
            });
          });
    }
  }
};
</script>
